




















import Vue from 'vue';
import { UserModel } from '@/@types/member';

export default Vue.extend({
  name: 'SubstantiationAlert',
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
  },
});
